<template>
  <div class="default-panel-ctnr">
    <div class="default-panel-wrp">
      <div class="default-bg">
        <img class="image" src="@/images/spot/default_bg.png" />
      </div>
      <div class="content-wrapper">
        <div class="title">
          <div class="line line-left"></div>
          <div class="text">{{ $t("message.spotyunjia.chuanspot") }}</div>
          <div class="line line-right"></div>
        </div>
        <div class="content-panel">
          <div class="item">
            <div class="image-wrapper">
              <img class="image" src="@/images/spot/1.png" />
            </div>
            <div class="text">
              {{ $t("message.spotyunjia.chuansi10") }}
            </div>
          </div>
          <div class="item">
            <div class="image-wrapper">
              <img class="image" src="@/images/spot/2.png" />
            </div>
            <div class="text">
              {{ $t("message.spotyunjia.shishibi") }}
            </div>
          </div>
          <div class="item">
            <div class="image-wrapper">
              <img class="image" src="@/images/spot/3.png" />
            </div>
            <div class="text">
              {{ $t("message.spotyunjia.yunjiading") }}
            </div>
          </div>
          <div class="item">
            <div class="image-wrapper">
              <img class="image" src="@/images/spot/4.png" />
            </div>
            <div class="text">{{ $t("message.spotyunjia.xiancangsuo") }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-wrapper">
      <img class="image" src="@/images/spot/block_big.png" />
      <img class="image" src="@/images/spot/block_small.png" />
      <img class="image" src="@/images/spot/block_gray.png" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.default-panel-ctnr {
  position: relative;
  width: 100%;
  .default-panel-wrp {
    position: relative;
    min-height: calc(100vh - 102px - 84px);
    overflow: hidden;
    .default-bg {
      position: absolute;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;
      overflow: hidden;
      //   transform: translateX(-50%);
      //   -webkit-transform: translateX(-50%);
      //   -ms-transform: translateX(-50%);
      //   -moz-transform: translateX(-50%);
      //   -o-transform: translateX(-50%);
      width: 100%;
      margin: auto;
      overflow: hidden;
      // filter: blur(20px);
      .image {
        margin: auto;
        width: 1200px;
        height: auto;
        display: block;
        position: relative;
        top: 60px;
      }
    }

    .content-wrapper {
      width: 1200px;
      position: relative;
      margin: auto;
      z-index: 3;
      padding-top: 120px;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        .line {
          width: 43px;
          height: 2px;
          border-radius: 1px;
          &.line-left {
            background: linear-gradient(-90deg, #818591 0%, #ffffff 100%);
          }
          &.line-right {
            background: linear-gradient(90deg, #818591 0%, #ffffff 100%);
          }
        }
        .text {
          margin: 0 10px;
          font-weight: 800;
          font-size: 24px;
          color: #2c2d33;
        }
      }
      .content-panel {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 90px;
        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 284px;
          flex-direction: column;

          .image-wrapper {
            width: 164px;
            height: 154px;
            display: flex;
            align-items: center;
            justify-content: center;
            .image {
              display: block;
              width: 100%;
              height: auto;
            }
          }
          .text {
            margin-top: 24px;
            font-size: 16px;
            font-weight: 500;
            color: #595c66;
          }
        }
      }
    }
  }
  .bg-wrapper {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .image:nth-child(1) {
      width: 260px;
      position: absolute;
      top: 78px;
      left: -20px;
      opacity: 0.7;
    }
    .image:nth-child(2) {
      opacity: 0.7;
      width: 150px;
      position: absolute;
      top: 30px;
      right: -30px;
    }
    .image:nth-child(3) {
      opacity: 0.7;
      width: 100px;
      position: absolute;
      bottom: 86px;
      right: 126px;
    }
  }
}
@media screen and (max-width: 1366px) {
  .default-panel-ctnr {
    .default-panel-wrp {
      //   min-height: 600px;
      .default-bg {
        .image {
          top: 40px;
        }
      }

      .content-wrapper {
        padding-top: 60px;
        .content-panel {
          margin-top: 70px;
        }
      }
    }
    .bg-wrapper {
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .image:nth-child(1) {
        width: 180px;
        position: absolute;
        top: 78px;
        left: -50px;
        opacity: 0.7;
      }
      .image:nth-child(2) {
        opacity: 0.7;
        width: 150px;
        position: absolute;
        top: 30px;
        right: -30px;
      }
      .image:nth-child(3) {
        opacity: 0.7;
        width: 100px;
        position: absolute;
        bottom: -10px;
        right: 106px;
      }
    }
  }
}
</style>
